import { Card, CardContent, Grid, LinearProgress } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem.jsx';
import { ParseUriParams } from 'helpers/UriReader';
import { Logout, GetUserToken } from 'helpers/UserHelper';
import { FnaResults } from 'queries/fna/queries';
import React from 'react';
import { Query } from 'react-apollo';
import ReactJson from 'react-json-view';
import { Redirect } from 'react-router';

class FnaResultsJson extends React.Component {
	render() {
		const params = ParseUriParams(this.props.location.search);
		const { fnaId } = params;

		return (
			<Query
				query={FnaResults}
				variables={{
					fnaId: fnaId,
					token: GetUserToken()
				}}
				fetchPolicy="cache-and-network"
			>
				{({ loading, error, data, refetch }) => {
					if (loading) {
						return (
							<React.Fragment>
								<LinearProgress />
							</React.Fragment>
						);
					}

					if (
						error &&
						error.message &&
						error.message === 'GraphQL error: invalid token'
					) {
						Logout();
						return <Redirect to="/app/portal/login" />;
					}

					console.log('data', data.FnaResults);

					return (
						<Grid container>
							<GridItem xs={12} sm={12} md={10} style={{ margin: 'auto' }}>
								<Card>
									<CardContent>
										<ReactJson
											name={'Fna Results'}
											src={data.FnaResults.FnaResultObj}
											displayObjectSize={false}
											displayDataTypes={false}
										/>
									</CardContent>
								</Card>
							</GridItem>
						</Grid>
					);
				}}
			</Query>
		);
	}
}
export default FnaResultsJson;



// WEBPACK FOOTER //
// ./src/views/Fna/FnaResultsJson.jsx